import Nullstack from 'nullstack';
export default function IconDevicesPcOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-devices-pc-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 9v10h-6v-14h2"
  }), "   ", Nullstack.element("path", {
    d: "M13 9h9v7h-2m-4 0h-4v-4"
  }), "   ", Nullstack.element("path", {
    d: "M14 19h5"
  }), "   ", Nullstack.element("path", {
    d: "M17 17v2"
  }), "   ", Nullstack.element("path", {
    d: "M6 13v.01"
  }), "   ", Nullstack.element("path", {
    d: "M6 16v.01"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}